// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"6a518a3d","57":"66aa6334","124":"151ea723","353":"eeb7f88c","449":"8081c234","453":"33f095f1","660":"d80cde22","697":"0f1668c8","712":"85d81227","819":"a4d3a19c"}[chunkId] + ".chunk.js";
};